import { storeInit, storeClear, startRequest, endRequest, openDialog, closeDialog, closeDialogNotFormat, checkAccess } from './actions';
import { intl } from './../../core/globalIntl';

const dialogInfo = {
    type: ['ok', 'okcancel', 'close'],
    title: '',
    context: '',
    action: '',
    open: false,
};

const openDialogOperation = ({ type, title, message, action, notFormat }) => {
    dialogInfo.type = type;
    dialogInfo.title = title;
    dialogInfo.context = message;
    dialogInfo.action = action;
    dialogInfo.open = true;
    dialogInfo.notFormat = (notFormat) ? true : false;
    dialogInfo.address = window.location.pathname;
    return dispatch => {
        dispatch(openDialog(dialogInfo));
    };
};

const closeDialogOperation = () => {
    return dispatch => {
        dispatch(closeDialog());
    };
};

const closeDialogNotFormatOperation = () => {
    return dispatch => {
        dispatch(closeDialogNotFormat());
    };
};

const accessInfo = {
    time: null,
};

const checkAccessOperation = () => {
    //UTC変換したタイムスタンプを保持
    accessInfo.time = (new Date(Date.now() + new Date().getTimezoneOffset() * 60000)).getTime();
    return (dispatch) => {
        dispatch(checkAccess(accessInfo));
    };
};

const checkResponseOperation = (res, elseMessageId) => {
    return (dispatch, getState) => {

        console.log('------checkResponseOperation------');
        console.log(res);
        //ステータスコードを取得
        let statusCode = '';
        if (typeof res.status !== "undefined") {
            statusCode = res.status;
        }
        console.log(statusCode);

        //ステータスコードが200の場合
        if (statusCode === 200) {
            console.log('------statusCode_200------');
            //処理を終了
            return true;
        }
        
        //ダイアログの共通設定
        dialogInfo.title = '';
        dialogInfo.action = '';
        dialogInfo.open = true;
        dialogInfo.notFormat = false;
        
        //ステータスコードが502(Lambdaタイムアウト)または429(kintone同時100)の場合
        if (statusCode === 429) {
            console.log('------statusCode_429------');
            let mes = intl.formatMessage({ id: 'dialog.status429' });
        
            dialogInfo.type = 'close';
            dialogInfo.notFormat = true;
            dialogInfo.context = mes;
            
            //ダイアログ表示
            dispatch(openDialog(dialogInfo));
            
            //処理を終了
            return false;
        }

        //その他のエラーの場合
        console.log('------statusCode_Else------');
        dialogInfo.type = 'error';
        
        if (typeof elseMessageId !== "undefined") {
            dialogInfo.context = elseMessageId;
        } else {
            dialogInfo.context = 'dialog.status429.errorElse';
        }

        //ダイアログ表示
        dispatch(openDialog(dialogInfo));
        return false;
    };
};

const confirmDialogOperation = ({ confirmType, action }) => {
    return (dispatch, getState) => {

        console.log('------confirmDialogOperation------');
        dialogInfo.type = 'okcancel';
        dialogInfo.title = '';
        dialogInfo.action = action;
        dialogInfo.open = true;
        dialogInfo.notFormat = false;

        switch (confirmType) {
            //登録
            case 'register':
                dialogInfo.context = 'Dialog.context.register';
                break;
            
            //更新
            case 'update':
                dialogInfo.context = 'Dialog.context.update';
                break;
            
            //削除
            case 'delete':
                dialogInfo.context = 'Dialog.context.delete';
                break;

            //一括確認
            case 'bulkCheck':
                dialogInfo.context = 'Dialog.context.bulkCheck';
                break;
            //承認
            case 'approval':
                dialogInfo.context = 'Dialog.context.approval';
                break;
            //承認取消
            case 'approvalCancel':
                dialogInfo.context = 'Dialog.context.approvalCancel';
                break;
            //アップロード
            case 'upload':
                dialogInfo.context = 'Dialog.context.upload';
                break;
        }
        //ダイアログ表示
        dispatch(openDialog(dialogInfo));
    };
};

export default {
    storeInit,
    storeClear,
    startRequest,
    endRequest,
    openDialogOperation,
    closeDialogOperation,
    closeDialogNotFormatOperation,
    checkAccessOperation,
    checkResponseOperation,
    confirmDialogOperation
};
